import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { Component, Inject } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-guest-payment-clear',
    template: ``
})
export class GuestPaymentClear {
    constructor(@Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
                @Inject(Router) private router: Router) {

        guestPaymentStore.clearAllGuest()
        this.router.navigateByUrl('/guestpayment', { state: { location: 'replace' } })
    }
}

